export enum AccountType {
  REVENUE,
  EXPENSE
}
